import React, { ReactElement } from 'react';
import {
  statusIconBlackList,
  getStatusColor,
  getLineStatusIcon,
} from '../../../utils';
import { CustomTooltip } from '../Tooltip/Tooltip';
import startCase from 'lodash.startcase';
import makeStyles from '@material-ui/core/styles/makeStyles';
import theme from '../../../themes/CBB/theme';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme: any) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: theme.spacing(3),
    position: 'relative',
    paddingRight: theme.spacing(1),
    paddingTop: '2px',
    paddingBottom: '2px',
    backgroundColor: ({ filter }: any) =>
      filter ? 'transparent !important' : '',
  },
  lineIconContainer: {
    width: 20,
    minWidth: 20,
    height: 20,
    borderRadius: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  lineIconStatus: {
    marginRight: theme.spacing(0.5),
    marginLeft: theme.spacing(1),
  },
  activeRequest: {
    position: 'absolute',
  },
  container: {
    display: 'inline-block',
  },
  clickable: {
    cursor: 'pointer',
    '& .MuiTypography-root': {
      '&.MuiTypography-root': {
        cursor: 'pointer',
      },
    },
  },
}));

function StatusIcon({
  status,
  formattedStatus,
}: {
  status: string;
  formattedStatus: string;
}): ReactElement {
  if (statusIconBlackList.includes(status)) return <></>;
  const statusIcon = getLineStatusIcon(status);
  if (statusIcon) {
    return statusIcon;
  }
  return <img src={`/status/${status}.svg`} alt={formattedStatus} />;
}

export default function Status({
  status,
  textClassName = '',
  imgClassName = '',
  filter = false,
  label = undefined,
  isClickable = false,
  tooltipChildEl = undefined,
  onClick = () => {},
}) {
  const classes = useStyles({ filter });
  let formattedStatus = label ?? startCase(status);

  return (
    <CustomTooltip
      arrow
      placement="left"
      enterDelay={500}
      enterNextDelay={500}
      title={tooltipChildEl ?? ''}
    >
      <div className={classes.container} onClick={onClick}>
        <div
          style={{
            backgroundColor: getStatusColor(theme, status),
          }}
          className={`${classes.root} ${isClickable ? classes.clickable : ''}`}
        >
          <div
            className={
              classes.lineIconContainer +
              ' ' +
              imgClassName +
              classes.lineIconStatus
            }
          >
            <StatusIcon status={status} formattedStatus={formattedStatus} />
          </div>
          <Typography className={textClassName} variant="subtitle1">
            {formattedStatus}
          </Typography>
        </div>
      </div>
    </CustomTooltip>
  );
}
